<table mat-table [dataSource]="folders" class="folderTable">
  <ng-container matColumnDef="folder">
    <th mat-header-cell *matHeaderCellDef>Папка</th>
    <td mat-cell *matCellDef="let folder">{{ folder.description }}</td>
  </ng-container>
  <ng-container matColumnDef="menu">
    <th mat-header-cell *matHeaderCellDef>
      <button mat-icon-button (click)="addFolder()">
        <mat-icon>add</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let folder">
      <button mat-icon-button color="warn" (click)="removeFolder(folder.id)">
        <mat-icon>remove</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
</table>
